const en = require('./en-US.json');
const it = require('./it-IT.json');
const fr = require('./fr.json');
const de = require('./de.json');

module.exports = { 'en-US': en, 'it-IT': it, fr, 'de-DE': de };
